import type { AuthUser } from '../types';
import { getPostLoginRoute, type PostLoginRoute } from './userMode';

export type AuthenticatedDestination = PostLoginRoute | '/complete-profile';

export function requiresProfileCompletion(user: AuthUser | null | undefined): boolean {
  return user?.requiresProfileCompletion === true;
}

export function getAuthenticatedDestination(user: AuthUser): AuthenticatedDestination {
  if (requiresProfileCompletion(user)) {
    return '/complete-profile';
  }
  return getPostLoginRoute(user);
}
